/* eslint-disable */
import React, { useState } from 'react';
import { Loader, Segment } from 'semantic-ui-react';

const DocxFileViewer = (props) => {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setLoading(true);
    const url = props.fileURL;

    const file = new XMLHttpRequest();
    file.open('GET', url, true);
    file.send();
    file.responseType = 'arraybuffer';

    file.onreadystatechange = async () => {
      if (file.readyState === 4 && file.status === 200) {
        try {
          const mammoth = await import('mammoth');
          mammoth.default
            .convertToHtml({ arrayBuffer: file.response }, { includeDefaultStyleMap: true })
            .then((result) => {
              setHtml(result.value);
              setLoading(false);
            })
            .catch((e) => {
              // eslint-disable-next-line no-console
              console.log('Could not get File', e);
              setLoading(false);
            });
        } catch (importError) {
          // eslint-disable-next-line no-console
          console.log('Could not import mammoth', importError);
          setLoading(false);
        }
      }
    };
  }, [props.fileURL]);

  return (
    <div className="documentviewer-document-container docx">
      <Segment className="documentviewer-document-wrapper docx">
        <div className="wrapper">
          <Loader active={loading} inline="centered">
            Loading
          </Loader>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </Segment>
    </div>
  );
};

export default DocxFileViewer;
